import { render } from "./BlogCoverPreview.vue?vue&type=template&id=6f368afe&scoped=true"
import script from "./BlogCoverPreview.vue?vue&type=script&lang=js"
export * from "./BlogCoverPreview.vue?vue&type=script&lang=js"

import "./BlogCoverPreview.vue?vue&type=style&index=0&id=6f368afe&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f368afe"]])

export default __exports__